import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { SectionHeader } from "@/components/site/Reveal";

export const WhyChooseUs = () => {
  const { t } = useLang();
  return (
    <section id="why" className="py-24 sm:py-32 relative" data-testid="why-section">
      <div className="container-x">
        <SectionHeader tag={t.why.tag} title={t.why.title} />
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-px mt-14 rounded-2xl overflow-hidden border border-white/10 bg-white/10">
          {t.why.items.map((item, i) => (
            <motion.div
              key={i}
              data-testid={`why-item-${i}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: (i % 4) * 0.07 }}
              className="group bg-[#0B132B] hover:bg-[#1C2539] p-8 transition-colors duration-300"
            >
              <div className="font-display font-extrabold text-4xl text-white/10 group-hover:text-[#E85D04] transition-colors">
                {String(i + 1).padStart(2, "0")}
              </div>
              <h3 className="font-display font-bold text-lg mt-5">{item.title}</h3>
              <p className="text-[#9CA3AF] text-sm mt-2 leading-relaxed">{item.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
